import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './dropdown-multi-select.scss';
import clsx from 'clsx';
import Dropdown, { DropdownTypes, DropdownPlacements } from '../dropdown';
import DropdownMultiSelectSelector from './dropdown-multi-select-selector';

const DropdownMultiSelect = ({
  label, items, placeholder, renderPlaceholderIcon,
  onSelect, onClose, children, avatarView, withSearch,
  placement, className, disabled, showLabelInline, onSelectionClear, dropdownOpen,
  renderCustomView, enableCustomView, withClearSelection,
}) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [processedItems, setProcessedItems] = useState([]);

  useEffect(() => {
    let procItems = [];
    let selItems = [];

    for (let i = 0; i < items.length; i += 1) {
      procItems = [...procItems, { ...items[i], type: DropdownTypes.MULTI_SELECT }];
      if (items[i].selected) {
        selItems = [...selItems, items[i]];
      }
    }

    setSelectedItems(selItems);
    setProcessedItems(procItems);
  }, [items]);

  const getSelector = () => {
    if (children) {
      return children;
    }

    return (
      <DropdownMultiSelectSelector
        items={selectedItems}
        placeholder={placeholder}
        renderPlaceholderIcon={renderPlaceholderIcon}
        disabled={disabled}
        label={label}
        showLabelInline={showLabelInline}
        dropdownOpen={dropdownOpen}
      />
    );
  };

  const handleItemClicked = (id) => {
    if (onSelect && typeof onSelect === 'function') {
      onSelect.call(null, id);
    }
  };

  const getDropdown = () => {
    if (disabled) {
      return getSelector();
    }
    return (
      <Dropdown
        withSearch={withSearch}
        items={processedItems}
        onItemClick={handleItemClicked}
        onClose={onClose}
        closeOnClick={false}
        avatarView={avatarView}
        placement={placement}
        withClearSelection={withClearSelection}
        onSelectionClear={onSelectionClear}
        renderCustomView={renderCustomView}
        enableCustomView={enableCustomView}
      >
        {getSelector()}
      </Dropdown>
    );
  };

  return (
    <div className={clsx('dd-multi-select-cont', className)}>
      {!showLabelInline && label && (
        <div className="dd-multi-select-label">
          {label}
        </div>
      )}
      {getDropdown()}
    </div>
  );
};

DropdownMultiSelect.propTypes = {
  label: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    icon: PropTypes.func,
    image: PropTypes.string,
    shortcut: PropTypes.string,
    helper: PropTypes.string,
    disabled: PropTypes.bool,
    selected: PropTypes.bool,
  })),
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
  placeholder: PropTypes.string,
  renderPlaceholderIcon: PropTypes.func,
  children: PropTypes.element,
  avatarView: PropTypes.bool,
  withSearch: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  placement: PropTypes.oneOf(Object.values(DropdownPlacements)),
  showLabelInline: PropTypes.bool,
  onSelectionClear: PropTypes.func,
  dropdownOpen: PropTypes.bool,
  renderCustomView: PropTypes.func,
  enableCustomView: PropTypes.bool,
  withClearSelection: PropTypes.bool,
};

DropdownMultiSelect.defaultProps = {
  label: '',
  items: [],
  onSelect: () => {},
  onClose: () => {},
  placeholder: '',
  renderPlaceholderIcon: null,
  children: null,
  avatarView: false,
  withSearch: false,
  disabled: false,
  className: '',
  placement: DropdownPlacements.BOTTOM,
  showLabelInline: false,
  onSelectionClear: () => {},
  dropdownOpen: false,
  renderCustomView: () => {},
  enableCustomView: false,
  withClearSelection: true,
};

export {
  DropdownMultiSelect as default,
  DropdownPlacements,
};
